module.exports = __webpack_public_path__ + "img/workspace_premium.73747544.svg";